<ng-container *ngIf="filter != null; else noFilterConfig">
  <div [ngSwitch]="filter?.type" class="filter">
    <!-- RANGE -->
    <ng-container *ngSwitchCase="'range'">
      <cbre-range
        class="full"
        [form]="form"
        [filter]="filter"
        [showLabel]="showLabel"
        (filterOptionChange)="filterOptionChange.emit($event)"
      ></cbre-range>
    </ng-container>

    <!-- PERIOD RANGE -->
    <!-- NOTE: TO BE IMPLEMENTED
    <ng-container *ngSwitchCase="'period'" >
      <miq-period-item class="full" [form]="form" [filter]="filter" [aggregation]="aggregation"></miq-period-item>
    </ng-container>
    -->

    <!-- MULTI SELECT -->
    <ng-container *ngSwitchCase="'multi'">
      <cbre-multi-select
        class="full"
        [form]="form"
        [filter]="filter"
        [aggregations]="aggregations"
        [showLabel]="showLabel"
      ></cbre-multi-select>
    </ng-container>
    <ng-container> </ng-container>

    <!-- EQUALS || NON-EQUALS -->
    <ng-container *ngSwitchDefault>
      <cbre-equal-filter
        class="full"
        [form]="form"
        [filter]="filter"
        [aggregations]="aggregations"
        [showLabel]="showLabel"
        (filterOptionChange)="filterOptionChange.emit($event)"
      ></cbre-equal-filter>
    </ng-container>

    <mat-icon *ngIf="canRemoveFilter" (click)="removeFilter.emit(filter)">close</mat-icon>
  </div>
</ng-container>

<!-- else missing filter configuration -->
<ng-template #noFilterConfig> Missing Filter Configuration </ng-template>
